<template>
  <span class="tooltip-custom ms-1">
    <!-- <span class="text-primary fw-bold ms-1">?</span> -->
    <span class="icon-help">?</span>
    <span class="tooltip-text">
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    text: String
  }
}
</script>

<style scoped>
.icon-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #0056FF;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

.tooltip-text{
  left: 0 !important;
  transform: none !important;
}
</style>